import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BrochurePopup from './BrochurePopup';
import RenovationPopup from './RenovationPopup';
import CookieBanner from './CookieBanner';
import ScrollToTop from './ScrollToTop';

const AppShell = () => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [renovationOpen, setRenovationOpen] = useState(false);
  const renovationTimerRef = useRef(null);

  const location = useLocation();
  const isHome = location.pathname === '/';

  // Priročnik se odpre samo ob ročnem kliku.
  const openPopup = () => setPopupOpen(true);
  const closePopup = () => setPopupOpen(false);

  // Prvi prikaz obvestila po 3 sekundah.
  useEffect(() => {
    renovationTimerRef.current = setTimeout(() => {
      setRenovationOpen(true);
    }, 3000);

    return () => clearTimeout(renovationTimerRef.current);
  }, []);

  // Po vsakem zaprtju se obvestilo ponovno pokaže čez 60 sekund.
  const closeRenovationPopup = () => {
    setRenovationOpen(false);

    clearTimeout(renovationTimerRef.current);

    renovationTimerRef.current = setTimeout(() => {
      setRenovationOpen(true);
    }, 60000);
  };

  return (
    <div className="min-h-screen flex flex-col bg-vd-bg">
      <ScrollToTop />

      <Header onBrochureClick={openPopup} showBrochureCTA={isHome} />

      <div className="pt-20 flex-1">
        <Outlet context={{ openPopup }} />
      </div>

      <Footer />

      <BrochurePopup open={popupOpen} onClose={closePopup} />

      <RenovationPopup
        open={renovationOpen}
        onClose={closeRenovationPopup}
      />

      <CookieBanner />
    </div>
  );
};

export default AppShell;
